import { jsx as _jsx } from "react/jsx-runtime";
import { InputAdornment, InputBase, useTheme } from '@mui/material';
import { SearchRegular } from '@fluentui/react-icons';
import useSearchInputStyles from './useSearchInputStyles';
const SearchInput = ({ placeholder, ...rest }) => {
    const theme = useTheme();
    const { SearchField: SearchFieldStyles } = useSearchInputStyles();
    const isLightMode = theme.palette.mode === 'light';
    return (_jsx(InputBase, { fullWidth: true, size: 'small', sx: SearchFieldStyles, placeholder: placeholder || 'Search', startAdornment: _jsx(InputAdornment, { position: 'start', children: _jsx(SearchRegular, { fontSize: 20, color: isLightMode ? 'white' : theme.palette.grey[900] }) }), ...rest }));
};
export default SearchInput;
